import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Lib } from 'app/lib/lib';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor() { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const prvEntityName: string = route.data.prvEntityName;

    if (Lib.instance.theUser?.token) {
      // if (prvEntityName && this.lib.checkUserRight(prvEntityName, 'read') === false) {
      //   this.lib.router.navigate(['/misc/not-authorized']);
      //   return false;
      // }
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    Lib.instance.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
